import {
    combineReducers
} from 'redux'
import { LOGOUT_USER } from "../actions/types";
import UserReducer from './rootReducers'

const combinedReducer = combineReducers({
    UserReducer: UserReducer
});
const rootReducer = (state, action) => {
    if (action.type === LOGOUT_USER) {
        delete state.UserReducer
    }
    return combinedReducer(state, action);
}

export default rootReducer